import Rest2 from '../Services/Rest2'

/**
 * @typedef {RegisterService}
 */
export default class RegisterService {

    constructor(){    
        this.resource = "/register"
        this.http = Rest2.build(null, this.resource);
      }
    
    static build(){    
    return new this();
    }

   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  create (record) {    
    return this.http.post('/xcreate', record)
  }


}